import React from "react";
import { Button } from "react-bootstrap";
// import bootstrapTable from 'react-bootstrap-table-next/lib/src/bootstrap-table';

export default class Forbidden extends React.Component {

    render () {
        return (
            <div>
                <br/><br/><br/><br/>
                <h1 style={{ textAlign: "center" }}>404 NOT FOUND</h1>
                <h1 style={{ textAlign: "center" }}>_________________________________________________________________________________</h1>
                <br/>
                <Button onClick={(e) => this.redirectHomepage(e)}
                        style={{ position: "absolute", width: "150px", marginLeft: "-82px", left: "50%" }}>back to
                    homepage</Button>
            </div>
        );
    }

    redirectHomepage (e) {
        e.preventDefault();
        this.props.history.push("/dashboard");
    }
}


// WEBPACK FOOTER //
// ./src/static/js/NotFound.js